import React, { Component } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './style.module.css';

type Props = {
	inputRef?: (input?: SVGElement | null | undefined) => unknown;
	testId?: string;
	labelledby: string;
};

/* An ultra lightweight checkbox that can be leveraged for performance optimisations.
 * It does not represent checkbox states in order to:
 * -  Minimise complexity/DOM
 * -  Minimise coupling with the 'real' checkbox (we only need to copy one set of styles).
 * Using event delegation, you can swap it out for the 'real' checkbox.
 */
// eslint-disable-next-line jira/react/no-class-components
export class CheckboxSkeleton extends Component<Props> {
	render() {
		const { inputRef, testId, labelledby } = this.props;

		/* Use an SVG here to more accurately recreate the checkbox, for example:
		 * border styles do not have the same layout implications as stroke styles, which
		 * could lead to visual issues when swapping between the skeleton and the 'real' checkbox.
		 */
		return (
			<svg
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				className={styles['checkbox-skeleton']}
				ref={inputRef}
				tabIndex={0}
				width="14"
				height="14"
				viewBox="0 0 14 14"
				role="checkbox"
				aria-checked="false"
				data-testid={testId}
				aria-labelledby={labelledby}
			>
				<rect x="1" y="1" width="12" height="12" rx="2" />
			</svg>
		);
	}
}
